var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestinationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1648_5267)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.3333,
    cy: 23.3333,
    r: 21.3333,
    fill: "#0094FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.3333,
    cy: 23.3333,
    r: 20,
    fill: "#0094FF",
    stroke: "white",
    strokeWidth: 2.66667
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1648_5267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1333 17.6667L26.92 16.6C26.84 16.1911 26.4755 15.8889 26.0489 15.8889H19.6667C19.1778 15.8889 18.7778 16.2889 18.7778 16.7778V30.1111C18.7778 30.6 19.1778 31 19.6667 31C20.1555 31 20.5555 30.6 20.5555 30.1111V24.7778H25.5333L25.7467 25.8445C25.8267 26.2622 26.1911 26.5556 26.6178 26.5556H31.2222C31.7111 26.5556 32.1111 26.1556 32.1111 25.6667V18.5556C32.1111 18.0667 31.7111 17.6667 31.2222 17.6667H27.1333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1648_5267",
    x: 0,
    y: 0,
    width: 50.6667,
    height: 50.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1648_5267"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1648_5267",
    result: "effect2_dropShadow_1648_5267"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1648_5267",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1648_5267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "white",
    transform: "translate(14.3333 12.3333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationMarker);
export default __webpack_public_path__ + "static/media/destination-marker.ca3af86c9f2d50428e23cf25efee2337.svg";
export { ForwardRef as ReactComponent };